import { Box, Container, IconButton } from "@mui/material"
import MemberMenu from "../Protected/MemberMenu"
import Icons from "../../../assets/js/Icons"

function Header({ toggleSidebar }) {

  return (
    <Box
      sx={{
        py: 1,
        boxShadow: "0 5px 20px #0000001a"
      }}
      component="header"
    >
      <Container maxWidth={false}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <IconButton
            size="medium"
            onClick={toggleSidebar}
            sx={{ color: "other.color1" }}
          >
            <Icons.SidebarLeftStroke />
          </IconButton>

          <MemberMenu />
        </Box>
      </Container>
    </Box>
  )
}

export default Header